import { FunctionComponent } from "react"
import { I_ApprovalHistory } from "../../interfaces"
import type { T_ApprovalAlias } from "../../types"
import approvalService from "../../ApprovalService"
import dayjs from "dayjs"
import "./ApprovalHistory.css"

interface Props {
    history: I_ApprovalHistory[]
    aliasRecord?: T_ApprovalAlias
}

const ApprovalHistory: FunctionComponent<Props> = (props) => {

    const { history, aliasRecord } = props

    const { timeFormat, retrieveEmployeeFromMap, applyAliasesToHistory } = approvalService

    const processedHistory = aliasRecord
        ? applyAliasesToHistory(aliasRecord, history)
        : history

    // console.log("history", history)
    // console.log("processedHistory", processedHistory)

    return (
        <div className="ApprovalHistory">
            {processedHistory.map((item, i) => {
                const approver = retrieveEmployeeFromMap(item.ApproverUserId)
                return (
                    <div className="ApprovalHistoryItem" key={i}>
                        <div className="ApprovalHistoryDetails">
                            <div className="ApprovalHistoryTopRow">
                                <span className="ApprovalHistoryApprover">
                                    {approver
                                        ? `${approver.FirstName} ${approver.LastName}`
                                        : `User: ${item.ApproverUserId > 0 ? item.ApproverUserId : "System"}`}
                                </span>
                                <span
                                    className={`ApprovalHistoryStatusBadge ApprovalHistoryStatus-${item.ApprovalStatusTypeId}`}
                                >
                                    {item.StatusName}
                                </span>
                            </div>
                            <div className="ApprovalHistoryActionLine">
                                {item.ActionName && <span>{`${item.ActionName}`}</span>}
                                {item.ActionedDateUTC && (
                                    <span className="ApprovalHistoryActionDate">
                                        {dayjs.utc(item.ActionedDateUTC).local().format(timeFormat)}
                                    </span>
                                )}
                            </div>
                            {item.Comments && (
                                <div className="ApprovalHistoryComments">“{item.Comments}”</div>
                            )}
                        </div>
                    </div>
                )
            })}
        </div>
    )
}

export default ApprovalHistory
